module.exports = __webpack_public_path__ + "static/020-fb16098f6375e1a34d28df114345e6c8.jpg";